import { render } from "./Contragents.vue?vue&type=template&id=be0beeba"
import script from "./Contragents.vue?vue&type=script&lang=js"
export * from "./Contragents.vue?vue&type=script&lang=js"
script.render = render

export default script